import React, { Component } from 'react'
import { post } from '../../utils/networking'
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";
import Footer from '../footer'
import Header from '../header'
import AboutUs from './aboutUs'
import { BrowserRouter } from 'react-router-dom'
import $ from 'jquery'
import LegalNotices from './legalNotices';
import CustomService from './customService/index';
import ContactUs from './contactUs/index';
import Faqs from './faqs/index';
import style from './style.css';

export default class PartnersFAQs extends Component {

    logOut() {
        window.localStorage.clear();
        window.location.replace("/");
    }

    render() {
        return (
            <BrowserRouter>
                <div id="user_page" className="partner_faqs">
                    <div className="user_header">
                        <p className="user_header_1">Partners FAQs</p>
                    </div>
                    <div className="user_detail">
                        <div className="column left_column">
                            <ul className="left_menu">
                                <li>
                                    <NavLink to="/page/about-us">
                                        <i className="fa fa-clone" aria-hidden="true"></i>
                                        <p>About Us</p>
                                    </NavLink>
                                </li>

                                <li className="points_sidebar_link">
                                    <NavLink to="#" onClick={this.show_points_sidebar}>
                                        <i className="fa fa-usd" aria-hidden="true"></i>
                                    </NavLink>
                                </li>

                                <li>
                                    <NavLink to="/faqs/legalnotices">
                                        <i className="fa fa-trophy" aria-hidden="true"></i>
                                        <p>Legal Notices</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/faqs/customservice">
                                        <i className="fa fa-user-o" aria-hidden="true"></i>
                                        <p>Customer Service</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/faqs/faqs">
                                        <i className="fa fa-faq" aria-hidden="true"></i>
                                        <p>FAQs</p>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/faqs/contactus">
                                        <i className="fa fa-cont" aria-hidden="true"></i>
                                        <p>Contact Us</p>
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                        <div className="column midle_column">
                            <Route exact path="/faqs" component={AboutUs} />
                            <Route exact path="/page/about-us" component={AboutUs} />
                            <Route exact path="/faqs/legalnotices" component={LegalNotices} />
                            <Route exact path="/faqs/customservice" component={CustomService} />
                            <Route exact path="/faqs/faqs" component={Faqs} />
                            <Route exact path="/faqs/contactus" component={ContactUs} />
                        </div>
                    </div>
                </div>
            </BrowserRouter>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/partnerfaqs/index.js